import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { faBuilding, faUser } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    ConfigService,
    CorporateInformationComponent,
    EventService,
    MenuEntryModel,
    ModalClass,
    TimesheetAndExpensesService,
    UserMasterService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
    public gid: string;
    public faUser = faUser;
    public displaySync = true;
    public isStartWorkAlreadySet: boolean;
    public displayWeeklyWorkTime: boolean;
    private destroy$ = new Subject<void>();
    private faBuilding = faBuilding;
    public corporateInformationEntry: MenuEntryModel;
    public showCorporateEntry: boolean;
    public constructor(
        private readonly configService: ConfigService,
        private readonly router: Router,
        private readonly timesheetAndExpensesService: TimesheetAndExpensesService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly translate: TranslateService,
        private readonly modalService: BsModalService,
        private readonly userMasterService: UserMasterService,
        private readonly eventService: EventService,
    ) {
        if (this.userMasterService.isPaceOnlineUser()) {
            this.router.events
                .pipe(
                    filter((event) => event instanceof NavigationEnd),
                    takeUntil(this.destroy$),
                )
                .subscribe(() => {
                    this.displaySync = this.router.url.indexOf(ConfigConstants.routeUrlConfirmation) < 0;
                });
        }

        this.displayWeeklyWorkTime =
            !this.userMasterService.isPaceOnlineUser() &&
            this.configService.getDisplayWeeklyWorkTime() &&
            !this.configService.isTimesheetDisabled();

        this.corporateInformationEntry = new MenuEntryModel(
            <string>this.translate.instant('SIDEMENU_BUTTON_CORPORATE_INFORMATION_LABEL'),
            () => this.openCorporateInfo(),
            this.faBuilding,
        );

        this.showCorporateEntry =
            this.userMasterService.isPaceOnlineUser() ||
            this.clientManager.isNgmP58() ||
            this.clientManager.isNgmAP0() ||
            this.clientManager.isPaceUS();
    }

    public ngOnInit(): void {
        this.isStartWorkAlreadySet = this.timesheetAndExpensesService.getStartOfWork().isValid();
        this.eventService.startWorkUpdated$
            .pipe(takeUntil(this.destroy$))
            .subscribe((status) => (this.isStartWorkAlreadySet = status));
        this.gid = this.configService.getUserFrontId();
    }

    private openCorporateInfo(): void {
        this.modalService.show(CorporateInformationComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_MEDIUM,
            ariaLabelledBy: 'corporate-information-modal-title',
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
    }
}
